  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 120,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
      });
